import React from 'react';
import { localStorage, sessionStorage } from "./../state/utils/storage";

export default function useCoverageState(citys) {

  const [isCoverage, setCoverage] = React.useState(true);

  const validateCoverage = () => {
    let userData = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
    if (userData) {
      let userCity = userData.mainCity ? userData.mainCity.toString() : "";
      const response = citys.filter(city => ((city.codigo.toString() === userCity) && (city.coverage === "true"))).length > 0;
      setCoverage(response);
      return response
    }
  };

  return [isCoverage, validateCoverage];
}